
import React from 'react';

import "./Forms.scss";
import CONSTANTS from '../../Constants';
// add .error to component for error state.

const Input = (props) => {

  const { label = '', errorLabel = '', Type = 'text', Selected = '', isDisabled = false, isAutoFocus = false } = props;
  // const isInvalid = (this.props.isInvalid.length ? this.props.isInvalid : '');
  const distanceStyle = props.name === 'distance' ? 'distance-field' : ''
  const visitedClass = props.value ? 'input-visited' : ''
  return (
    <div className="form-group">
      <div className='form-input'>
        <div className='form-label'>
          <label htmlFor={Type} for={`id-`+props.name}>{label}</label>
        </div>

        <div className={`form-field ${distanceStyle}`} >
          <input
            id={`id-`+props.name}
            type={Type}
            name={props.name}
            placeholder={props.placeholder}
            onChange={props.onChange}
            value={props.Value}
            className={(errorLabel.length < 1 ? "" : "error")}
            defaultValue={Selected || props.defaultValue}
            disabled={isDisabled}
            autoFocus={isAutoFocus}
            onBlur={props.onBlur}
            aria-label={label}
          />
          {props.children}
          {props.name === 'distance' && <span tabIndex="0" className='distance-unit'>{CONSTANTS.LABELS.vehicule_step2_km2}</span>}
        </div>
      </div>
      {(errorLabel.length < 1 ? "" : <span tabIndex="0" className="input-errorLabel"> {errorLabel}</span>)}

    </div>
  );

}
export default Input;
